import axios, { AxiosError } from 'axios';

export const api = axios.create({
    baseURL: import.meta.env.VITE_BASE_URL,
});

api.interceptors.request.use(
    (config) => {
        config.headers['sdatxtoken'] = window.sessionStorage.getItem('sdatxtoken');
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        throw new AxiosError(`${error.response?.request.responseURL} ${error.response?.data} ${error.stack}`);
    }
);
